import { useQuery } from '@tanstack/react-query';

import { listBusinesses } from '../api/endpoints/businesses';
import { getHqActivity, getHqTeam } from '../api/endpoints/hq';
import { listPlatformExpenses } from '../api/endpoints/expenses';
import { listPayments } from '../api/endpoints/payments';
import { ADMIN_BUSINESSES_QUERY_KEY } from '../lib/roster';

/**
 * The reads Dale HQ shares between its places. Each place mounts its own shell,
 * so these live in the query cache under one key each: a read already made is
 * shown at once and asked again only when it is older than half a minute.
 */

const FRESH_MS = 30_000;

export const ADMIN_ALL_PAYMENTS_QUERY_KEY = ['admin-payments', 'all'];
export const ADMIN_EXPENSES_QUERY_KEY = ['admin-expenses'];
export const HQ_ACTIVITY_QUERY_KEY = ['admin-hq-actividad'];
export const HQ_TEAM_QUERY_KEY = ['admin-hq-equipo'];

export const useBusinessesQuery = () =>
  useQuery({ queryKey: ADMIN_BUSINESSES_QUERY_KEY, queryFn: listBusinesses, staleTime: FRESH_MS });

export const usePaymentsQuery = () =>
  useQuery({ queryKey: ADMIN_ALL_PAYMENTS_QUERY_KEY, queryFn: () => listPayments(), staleTime: FRESH_MS });

export const useExpensesQuery = () =>
  useQuery({ queryKey: ADMIN_EXPENSES_QUERY_KEY, queryFn: listPlatformExpenses, staleTime: FRESH_MS });

export const useActivityQuery = (month: string) =>
  useQuery({ queryKey: [...HQ_ACTIVITY_QUERY_KEY, month], queryFn: () => getHqActivity(month), staleTime: FRESH_MS });

export const useTeamQuery = () => useQuery({ queryKey: HQ_TEAM_QUERY_KEY, queryFn: getHqTeam, staleTime: FRESH_MS });
